import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import env from 'env/env';

import ContentLocation from 'components/ContentLocation';
import MetaHeader from 'components/MetaHeader';
import NotFound from 'components/NotFound/NotFound';
import PageTitle from 'components/PageTitle';
import Breadcrumbs from 'components/Breadcrumbs';

import { getJsonLd, getBreadcrumbsJsonLd } from 'components/CmsPage/utils';
import { scrollToY } from 'utils/scroll';

import { useWtrSelector } from 'redux/hooks';
import { getCmsPage } from 'redux/modules/cms-page/selectors';
import { getLocationByName } from 'redux/modules/content/selectors';
import styles from './CmsPage.scss';

const CmsPage = () => {
  const components = useWtrSelector(state => getLocationByName(state, 'root')) || [];

  const {
    breadcrumbs = [],
    contentUrl = null,
    error = false,
    metaData = {},
    pageTitle = {},
    showPageTitle,
    loading,
  } = useWtrSelector(getCmsPage);

  useEffect(() => {
    if (!loading && window.location.hash) {
      const elementId = window.location.hash.replace('#', '');
      const focusElement = document.getElementById(elementId);

      if (focusElement) {
        setTimeout(() => {
          scrollToY(focusElement.offsetTop);
        }, 0);
      }
    }
  }, [loading]);

  if (error) return <NotFound />;

  const seoQuestionAndAnswerMetaData = getJsonLd(components);
  const seoSearchResultBreadcrumbsMetaData = getBreadcrumbsJsonLd(breadcrumbs, pageTitle.text);

  const canonicalHref = `https://${env.prodHost}/ecom/${contentUrl}`;

  return (
    <>
      <MetaHeader {...metaData} pageTitle={pageTitle} canonicalHref={canonicalHref} />
      {seoQuestionAndAnswerMetaData && (
        <Helmet>
          <script type="application/ld+json" data-testid="seo-meta-data-faqs">
            {JSON.stringify(seoQuestionAndAnswerMetaData)}
          </script>
        </Helmet>
      )}
      {seoSearchResultBreadcrumbsMetaData && (
        <Helmet>
          <script type="application/ld+json" data-testid="seo-meta-data-breadcrumbs">
            {JSON.stringify(seoSearchResultBreadcrumbsMetaData)}
          </script>
        </Helmet>
      )}
      <div className={styles.header}>
        {/* @ts-expect-error untyped component */}
        {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />}
        <div className="container-fluid">
          {showPageTitle && pageTitle && <PageTitle {...pageTitle} underline />}
        </div>
      </div>
      <div className={styles.content}>
        <ContentLocation name="root" />
      </div>
    </>
  );
};

CmsPage.displayName = 'CmsPage';

export default CmsPage;
